const LOG_OUT = 'account/log_out';
const LOGGED_OUT = 'account/logged_out';
const logOut = (returnPath)=>({
        type: LOG_OUT,
        returnPath
    })
;
const loggedOut = (returnPath)=>({
        type: LOGGED_OUT,
        returnPath
    })
;

export { LOGGED_OUT, LOG_OUT, logOut, loggedOut };
//# sourceMappingURL=actions.js.map
